<template>
  <div class="devDetailDW basicInfoContainer">
    <div class="detailsDrawerBody" :style="styleObject">
      <div class="basic detailsItem">
        <!-- <h4>基本信息</h4> -->
        <div class="details">
          <el-scrollbar wrap-class="scrollbar-wrapper" ref="myScrollbar">
            <ul>
              <!-- <li>
                <div class="label">子设备名称</div>
                <div class="value deviceName" :style="styleObj">
                  <el-input :title="datailsData.name" type="text" v-model="datailsData.name" :disabled="!commitFlag" :placeholder="datailsData.name"></el-input>
                </div>
              </li> -->
              <li>
                <div class="label">子设备Modbus地址</div>
                <div class="value">{{ datailsData.address }}</div>
              </li>
              <li>
                <div class="label">子设备ID</div>
                <div class="value">{{ datailsData.deviceId }}</div>
              </li>
              <li>
                <div class="label">sn号</div>
                <div class="value">{{ datailsData.sn }}</div>
              </li>
              <li>
                <div class="label">子设备类型说明</div>
                <div class="value">{{ datailsData.breakerType }}</div>
              </li>
              <li>
                <div class="label">生产厂商</div>
                <div class="value">{{ datailsData.productfactory }}</div>
              </li>
              <li>
                <div class="label">额定电流(A)</div>
                <div class="value">{{ datailsData.iRatedl }}</div>
              </li>
              <li>
                <div class="label">过电压告警值(V)</div>
                <div class="value">{{ datailsData.iHighU }}</div>
              </li>
              <li>
                <div class="label">欠电压告警值(V)</div>
                <div class="value">{{ datailsData.iLowU }}</div>
              </li>
              <li>
                <div class="label">漏电流告警值(%)</div>
                <div class="value">{{ datailsData.iHighLeakl }}</div>
              </li>
              <li>
                <div class="label">过电流告警值(%)</div>
                <div class="value">{{ datailsData.iCurrentLimit }}</div>
              </li>
              <li>
                <div class="label">生产厂商</div>
                <div class="value">{{ datailsData.iPowerLimit }}</div>
              </li>
              <li>
                <div class="label">端子温度告警值(℃)</div>
                <div class="value">{{ datailsData.fmaxTemprature }}</div>
              </li>
              <li>
                <div class="label">分合闸状态</div>
                <div class="value">{{ datailsData.status == 0 ? '分闸' : '合闸' }}</div>
              </li>
              <li>
                <div class="label">手动锁定状态</div>
                <div class="value">{{ datailsData.ilock == 0 ? '未手动锁定' : '1：手动锁定' }}</div>
              </li>
              <li>
                <div class="label">记录错误代码</div>
                <div class="value">{{ datailsData.error }}</div>
              </li>
              <li>
                <div class="label">报警状态</div>
                <div class="value">{{ datailsData.alarm == 1 ? '报警中' : '正常' }}</div>
              </li>
              <li>
                <div class="label">A相电压(V)</div>
                <div class="value">{{ datailsData.iOrgUa }}</div>
              </li>
              <li>
                <div class="label">B相电压(V)</div>
                <div class="value">{{ datailsData.iOrgUb }}</div>
              </li>
              <li>
                <div class="label">C相电压(V)</div>
                <div class="value">{{ datailsData.iOrgUc }}</div>
              </li>
              <li>
                <div class="label">A相电流(A)</div>
                <div class="value">{{ datailsData.fla }}</div>
              </li>
              <li>
                <div class="label">B相电流(A)</div>
                <div class="value">{{ datailsData.flb }}</div>
              </li>
              <li>
                <div class="label">C相电流(A)</div>
                <div class="value">{{ datailsData.flc }}</div>
              </li>
              <li>
                <div class="label">N相电流(A)</div>
                <div class="value">{{ datailsData.fin }}</div>
              </li>
              <li>
                <div class="label">A相总有功功率(KW)</div>
                <div class="value">{{ datailsData.fPhaP }}</div>
              </li>
              <li>
                <div class="label">B相总有功功率(KW)</div>
                <div class="value">{{ datailsData.fPhbP }}</div>
              </li>
              <li>
                <div class="label">C相总有功功率(KW)</div>
                <div class="value">{{ datailsData.fPhcP }}</div>
              </li>
              <li>
                <div class="label">总有功功率(KW)</div>
                <div class="value">{{ datailsData.fPsum }}</div>
              </li>
              <li>
                <div class="label">A相端子温度(℃)</div>
                <div class="value">{{ datailsData.fTempPha }}</div>
              </li>
              <li>
                <div class="label">B相端子温度(℃)</div>
                <div class="value">{{ datailsData.fTempPhb }}</div>
              </li>
              <li>
                <div class="label">C相端子温度(℃)</div>
                <div class="value">{{ datailsData.fTempPhc }}</div>
              </li>
              <li>
                <div class="label">N相端子温度(℃)</div>
                <div class="value">{{ datailsData.fTempPhn }}</div>
              </li>
              <li>
                <div class="label">A相正向电能(Kwh)</div>
                <div class="value">{{ datailsData.fKwhPha }}</div>
              </li>
              <li>
                <div class="label">B相正向电能(Kwh)</div>
                <div class="value">{{ datailsData.fKwhPhb }}</div>
              </li>
              <li>
                <div class="label">C相正向电能(Kwh)</div>
                <div class="value">{{ datailsData.fKwhPhc }}</div>
              </li>
              <li>
                <div class="label">总正向电能(Kwh)</div>
                <div class="value">{{ datailsData.fKWHsum }}</div>
              </li>
              <li>
                <div class="label">漏电流(mA)</div>
                <div class="value">{{ datailsData.fLeakCurrent }}</div>
              </li>
              <li>
                <div class="label">A相功率因数</div>
                <div class="value">{{ datailsData.fPFa }}</div>
              </li>
              <li>
                <div class="label">B相功率因数</div>
                <div class="value">{{ datailsData.fPFb }}</div>
              </li>
              <li>
                <div class="label">C相功率因数</div>
                <div class="value">{{ datailsData.fPFc }}</div>
              </li>
              <li>
                <div class="label">总功率因数</div>
                <div class="value">{{ datailsData.fPFsum }}</div>
              </li>
              <li>
                <div class="label">频率(Hz)</div>
                <div class="value">{{ datailsData.freq }}</div>
              </li>
              <!-- <li>
                <div class="label">故障状态</div>
                <div class="value">{{ datailsData.fault ? '故障':'完好' }}</div>
              </li> -->
              <!-- <li>
                <div class="label">是否删除</div>
                <div class="value">{{ !datailsData.isDelete ? '否':'是' }}</div>
              </li> -->
              <li>
                <div class="label">是否在线</div>
                <div class="value">{{ !datailsData.online ? '离线':'在线'}}</div>
              </li>
              <!-- <li>
                <div class="label">安装位置</div>
                <div class="value unitType" :style="styleObj">
                  <el-input :title="datailsData.installLocation" ref="addrInput" v-model="datailsData.installLocation" :disabled="!commitFlag" maxlength="50" :placeholder="datailsData.installLocation"></el-input>
                </div>
              </li> -->
              <!-- <li>
                <div class="label">安装经纬度:</div>
                <div class="value">{{ datailsData.installGps }}</div>
              </li> -->
              <!-- <li>
                <div class="label">创建时间</div>
                <div class="value">{{ datailsData.createTime }}</div>
              </li> -->
              <li>
                <div class="label">数据最新时间</div>
                <div class="value">{{ datailsData.updateTime?datailsData.updateTime:'无' }}</div>
              </li>
              <!-- <li>
                <div class="label">状态:</div>
                <div class="value">{{ datailsData.status}}</div>
              </li> -->
              <!-- <li>
                <div class="label">值</div>
                <div class="value">{{ datailsData.value?(datailsData.value+'&nbsp;'+datailsData.unit):'' }}</div>
              </li> -->
            </ul>
            <div class="submitBtns">
              <!-- <button class="delSome" v-if="!commitFlag" @click="editBasicinfo()">编辑</button>
              <button class="delSome" v-if="commitFlag" @click="submitBasicinfo()">提交</button>
              <button class="delSome uninstall" v-if="commitFlag" @click="cancelBasicinfo()">取消</button> -->
              <!-- <button class="delSome uninstall" @click="uninstallDevice()">拆卸</button> -->
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
    <div class="unitMap" :style="{left : mapShow ? '0' : '100%'}">
    <div class="closeBtn" @click="mapShow = false"><i class="el-icon-circle-close" /></div>
      <div class="mapBox" v-loading="mapLoading">
        <div class="mapSearch">
          <el-input ref="searchInput" v-model="mapSearch" placeholder="搜索地址"></el-input>
          <!-- <el-button type="primary" @click="searchMap">搜索</el-button> -->
        </div>
        <!-- <baidu-map class="map" :center="center" :zoom="zoom" @ready="mapReady" @click="mapClick" :scroll-wheel-zoom="true"> -->
        <baidu-map class="map" :center="center" :zoom="zoom" @ready="mapReady" @click="mapClick">
          <!-- 地图容器 -->
          <bm-view :style="{width:'100%',height: '100%'}"></bm-view>
          <bm-local-search :keyword="mapSearch" :auto-viewport="true" style="display:none;"></bm-local-search>
        </baidu-map>
        <div class="mapConfirm" v-if="locationSelected">
          <span>{{selectLocation.address}}</span><i @click.stop="saveLocation">保存位置</i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {BaiduMap,BmNavigation,BmView,BmGeolocation,BmCityList} from 'vue-baidu-map'
export default {
  components: {
    BaiduMap,
    BmNavigation,
    BmView,
    BmGeolocation,
    BmCityList
  },
  props: {
    deviceId: {
      type: Number,
      default: () => {
        return null;
      }
    },
    childId: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      mapShow:false,
      mapSearch: '',
      center: {
        lng: '116.404',
        lat: '39.915'
      },
      location:{
        lng: '116.404',
        lat: '39.915'
      },
      keyword: '',
      zoom: 14,
      baiduMap: null,
      map: null,
      geocoder: null,
      mapLoading:false,
      locationSelected:false,
      selectLocation:{},
      // selectAddress:{},
      styleObject: {
        height: ''
      },
      datailsData: {},
      disabled:false,
      mapWidth:0,
      mapHeight:0,
      commitFlag:false,
      styleObj:{},
      flag:false
    };
  },
  watch: {
    childId(newV) {
      console.log(newV);
    }
  },
  created() {
    this.mapWidth = document.body.clientWidth*0.8
    this.mapHeight = document.body.clientHeight*0.8
    // console.log(this.childId)-
    this.makeheight()
    this.detailDatas()
  },
  mounted() {

  },
  methods: {
    mapShowClick(){
      this.mapShow = true
      if(!this.locationSelected){
        this.mapLoading = true
      }
      //地图定位到选中项位置
      if(!this.datailsData.installGps){
        return
      }
      let map = this.map
      let BMap = this.baiduMap
      let installGps = this.datailsData.installGps.split(',')
      map.clearOverlays()
      this.center.lng = installGps[0] ? installGps[0] : '116.404'
      this.center.lat = installGps[1] ? installGps[1] : '39.915'
      let point = new BMap.Point(this.center.lng, this.center.lat);
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      map.panTo(point)
      let gc = new BMap.Geocoder();
      gc.getLocation(point, res => {
        // console.log(res);
        this.selectLocation = res
      })
    },
    detailDatas() { //详情
      this.request.get("/front/device/standardSwitch/child/" + this.childId).then((res) => {
        console.log(res);
        if (res.code === 200) {
          this.datailsData = res.data
        } else if (res.code === 500) {
          this.msg.warn(res.msg)
        }
      })
    },
    makeheight(height = 260) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    editBasicinfo(){
      this.commitFlag=true
      this.styleObj={
        'border':this.commitFlag?'1px solid #1089FF':'unset'
      }
      this.$refs.myScrollbar.wrap.scrollTop = 0
    },
    submitBasicinfo(){
      let params = {
        id: this.deviceId,
        name: this.datailsData.name,
        installLocation: this.datailsData.installLocation
      }
      this.$confirm('此操作将修改设备信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.request.put('/front/device/gateway/child',{},params).then(res => {
          if (res.code !== 200) {
            if(res.code==500){
              return this.$message.error(res.msg)
            }
            return
          }
          this.commitFlag=false
          this.styleObj={
            'border':this.commitFlag?'1px solid #1089FF':'unset'
          }
          this.$refs.myScrollbar.wrap.scrollTop = 0
          return this.$message.success('修改成功！')
          // return this.$message.success(res.msg)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消修改'
        });
      })
    },
    cancelBasicinfo(){
      this.commitFlag=false
      this.styleObj={
        'border':this.commitFlag?'1px solid #1089FF':'unset'
      }
      this.$refs.myScrollbar.wrap.scrollTop = 0
      this.detailDatas()
    },
    uninstallDevice(){
      this.$confirm('此操作将拆卸设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.request.post('/front/device/unInstall?id=' + this.deviceId).then(res => {
          if (res.code !== 200) {
            if(res.code==500){
              return this.$message.error(res.msg)
            }
            return
          }
          this.$router.push('/deviceGas')
          return this.$message.success(res.msg)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消拆卸'
        });
      })
    },
    saveLocation(){
      // this.selectAddress = this.selectLocation
      if(JSON.stringify(this.selectLocation) == "{}"){
        this.msg.warn("请您先选择地理位置")
        return
      }
      this.mapShow = false
      this.datailsData.installLocation = this.selectLocation.address
      this.datailsData.installGps = this.selectLocation.point.lng+','+this.selectLocation.point.lat
      // console.log(this.datailsData);
    },
    mapReady({ BMap, map }) {
      this.baiduMap = BMap
      this.map = map
      this.mapLoading = false
      this.locationSelected = true
      let point = new BMap.Point(this.center.lng, this.center.lat);
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      map.panTo(point)
      let gc = new BMap.Geocoder();
      gc.getLocation(point, res => {
        // console.log(res);
        this.selectLocation = res
      })
      let Geo = new BMap.Geocoder();
      this.geocoder = Geo
    },
    mapReady1({ BMap, map }) {
      let _this =this
      _this.baiduMap = BMap
      _this.map = map
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition( res => {
        console.log(res);
        _this.mapLoading = false
        _this.locationSelected = true
        if(!res){
          return
        }
        // console.log("转化前:" + res.longitude, res.latitude)
        var x_PI = 3.14159265358979324 * 3000.0 / 180.0
        var lat = +res.latitude
        var lng = +res.longitude
        var z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * x_PI)
        var theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * x_PI)
        var bd_lng = z * Math.cos(theta) + 0.0065
        var bd_lat = z * Math.sin(theta) + 0.006
        // console.log("转化后:" + bd_lng, bd_lat)
        _this.location.lng = bd_lng
        _this.location.lat = bd_lat
        if(!_this.flag){
          _this.center.lng = this.location.lng
          _this.center.lat = this.location.lat
          let point = new BMap.Point(_this.center.lng, _this.center.lat);
          var marker = new BMap.Marker(point); // 创建标注
          map.addOverlay(marker); // 将标注添加到地图中
          map.panTo(point)
          let gc = new BMap.Geocoder();
          gc.getLocation(point, res => {
            console.log(res);
            _this.selectLocation = res
          })
        }
        // console.log(point);
      }, {
        enableHighAccuracy: true
      })
      let Geo = new BMap.Geocoder();
      _this.geocoder = Geo
    },
    mapClick(e) {
      let map = this.map
      let BMap = this.baiduMap
      map.clearOverlays();
      var point = new BMap.Point(e.point.lng, e.point.lat);
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      this.geocoder.getLocation(point, res => {
        console.log(res);
        this.selectLocation = res
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.detailsDrawerBody {
  // padding: 10px 35px;

  .detailsItem {
    height: 100%;
    padding-left: 20px;

    h4 {
      font-size: 16px;
      color: #333;
      line-height: 38px;
      font-weight: bold;
      border-bottom: 1px solid #aaa;
    }

    .details {
      padding: 10px 0;
      height: 100%;

      ul {
        overflow: hidden;
        li {
          float: left;
          width: 33.33%;
          line-height: 38px;
          margin:0 0 5px 0;
          .label {
            // display: inline-block;
            vertical-align: middle;
            color: #bbb;
            width: 140px;
          }

          .value {
            // display: inline-block;
            // width: calc(100% - 200px);
            width: 300px;
            height: 38px;
            padding: 0 10px;
            box-sizing: border-box;
            vertical-align: middle;
            color: #888;
            background: rgba(16, 137, 255, 0.05);
            border-radius: 2px;
            .unit {
              margin-left: 10px;
            }
          }
        }
      }
      .submitBtns{
        overflow: hidden;
        .delSome{
          width: 82px;
          height: 36px;
          cursor: pointer;
          float: left;
          margin-right: 20px;
          font-size: 14px;
          font-family: AlibabaPuHuiTi-Medium;
          line-height: 36px;
          border: 0;
          color: #FFFFFF;
          background: #1089FF;
          border-radius: 2px;
          &:hover{
            background: #0774e0;
          }
        }
        .uninstall{
          background: #fff;
          border: 1px #1089FF solid;
          color: #1089FF;
          &:hover{
            background: rgba(16, 137, 255, 0.05);
          }
        }
      }
      .unitType {
        font-size: 0;
        position: relative;
        .imgPosition {
          position: absolute;
          width: 38px;
          height: 38px;
          right: 0px;
          top: 0px;
          cursor: pointer;

          img {
            margin:11px 0 0 11px;
            width: 16px;
            height: 16px;
            vertical-align: top;
          }
        }
      }
    }
  }

}
</style>
<style lang="scss">
.basicInfoContainer{
  font-family: AlibabaPuHuiTi-Regular;
  .deviceName{
    font-size: 0;
    .el-input {
      font-size: 0;
      display: inline-block;
      width: 100%;

      .el-input__inner {
        color: #888;
        height: 38px;
        line-height: 38px;
        font-size: 14px;
        padding: 0;
        border: unset;
        outline: unset;
        background: unset;
      }
    }
  }
  .unitType {
    font-size: 0;
    .el-input {
      font-size: 0;
      display: inline-block;
      width: 90%;

      .el-input__inner {
        color: #888;
        height: 38px;
        line-height: 38px;
        font-size: 14px;
        padding: 0;
        border: unset;
        outline: unset;
        background: unset;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .unitMap{
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.7);
    z-index: 10;
    transition:all 0.1s;
    .closeBtn {
      position: absolute;
      top: 30px;
      right: 80px;
      font-size: 50px;
      color: #fff;
      cursor: pointer;
    }
    .mapBox {
      position: absolute;
      width: 80%;
      height: 80%;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      overflow: hidden;
      .map {
        width: 100%;
        height: 100%;
      }

      .mapSearch {
        position: absolute;
        top: 10px;
        left: 10px;
        z-index: 1000;
        font-size: 0;

        .el-input {
          width: 300px;
          height: 40px;
          vertical-align: middle;
          margin-right: 10px;
          box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3);

          .el-input__inner {
            width: 300px;
            height: 40px;
          }
        }

        .el-button {
          vertical-align: middle;
          height: 40px;
          line-height: 40px;
          padding: 0 10px;
          box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3);
        }
      }

      .mapConfirm{
        position: absolute;
        bottom: 0px;
        left: 0px;
        right: 0px;
        background: rgba(0,0,0,0.8);
        padding: 10px 20px;
        cursor: pointer;
        span{
          float: left;
          color: #fff;
          font-size: 20px;
          width: 500px;
          line-height:36px;        
        }
        i{
          float: right;
          background: #f77a27;
          font-style: normal;
          height:36px;
          line-height:36px;
          border-radius: 18px;
          padding: 0 20px;
          color: #fff;
          font-size: 20px;
        }
      }
    }
  }
}
</style>
